import React from "react";

import { Col, Container, Row } from "react-bootstrap";
import TitleHeader from "../Header/TitleHeader";
import { motion } from "framer-motion";
import { ai_list, apps, bi_list, websites } from "../../utilities";

const SectionC = ({ id, onClick, tab, onPressItem }) => {
  const RenderContent = ({ animate, list }) => {
    return (
      <Row className="justify-content-md-center">
        {list.map((item) => {
          return (
            <Col className="pv20" md={3} sm={12} lg={3}>
              <motion.div
                animate={{
                  scale: animate,
                }}
                className="portfolioCard"
              >
                <div className="overlay" />
                {item?.icon && (
                  <img className="portfolioImg" src={item?.icon} />
                )}
                {list[list?.length - 1].id != item?.id ? (
                  <div class="content">
                    <h1
                      onClick={() => {
                        onPressItem(item);
                      }}
                      className={`title`}
                    >
                      {item?.title}
                    </h1>
                  </div>
                ) : (
                  <div class="last_content">
                    <h1 className={`lgtitle`}>{item?.title}</h1>
                  </div>
                )}
              </motion.div>
            </Col>
          );
        })}
      </Row>
    );
  };

  const switchTabs = () => {
    switch (tab) {
      case 1:
        return <RenderContent animate={[0, 0, 1, 1, 1]} list={apps} />;
        break;
      case 2:
        return <RenderContent animate={[0, 0, 1, 1, 1]} list={websites} />;
        break;
      default:
        break;
    }
  };

  const RenderHeader = ({ onClick, title, id }) => {
    return (
      <Col onClick={onClick} lg={1} className="center">
        <h5 className={tab == id ? `tabHeading1` : "tabHeading"}>{title}</h5>
      </Col>
    );
  };
  return (
    <Container id="tab_3">
      <motion.div className="container__services">
        <TitleHeader title={"Portfolio"} />
        <Row className="justify-content-md-center">
          <RenderHeader
            title={"Apps"}
            id={1}
            onClick={() => {
              onClick(1);
            }}
          />
          <RenderHeader
            title={"Websites"}
            id={2}
            onClick={() => {
              onClick(2);
            }}
          />
        </Row>
        {switchTabs()}
      </motion.div>
    </Container>
  );
};
export default SectionC;
